import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { useSectionAnimation } from '@/hooks/use-section-animation';

interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  containerClassName?: string;
  background?: 'light' | 'dark' | 'gradient' | 'none';
  direction?: 'left' | 'right' | 'up' | 'down';
  fullWidth?: boolean;
}

export const SectionWrapper = ({
  children,
  className,
  containerClassName,
  background = 'light',
  direction = 'up',
  fullWidth = false,
}: SectionWrapperProps) => {
  const animation = useSectionAnimation({ direction });

  const getBgClass = () => {
    switch (background) {
      case 'light':
        return 'bg-gray-50';
      case 'dark':
        return 'bg-gray-900';
      case 'gradient':
        return 'bg-gradient-to-br from-gray-900 to-gray-800';
      default:
        return '';
    }
  };

  return (
    <section 
      className={cn(
        'py-16 md:py-24 overflow-hidden',
        getBgClass(),
        className
      )}
    >
      <motion.div 
        ref={animation.ref}
        initial={animation.initial}
        animate={animation.animate}
        transition={animation.transition}
        className={cn(
          'container mx-auto px-4',
          !fullWidth && 'max-w-7xl',
          containerClassName
        )}
      >
        {children}
      </motion.div>
    </section>
  );
};
